<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <!-- Filter -->
    <a href="javascript:;" @click="toggleFilterSidebar()" class="button action toggle-sidebar-button fixed glyph hide-for-xxxlarge" data-sidebar-id="subnav" v-if="items.length > 0">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg>
      Filtrering
    </a>

    <div class="sidebar left fixed subnav responsive xxlarge-down table-filter-nav" id="subnav" v-if="items.length > 0">
      <div class="fixed-container">
        <ul>
          <li v-for="group in groups" v-bind:key="group.code">
            <a href="javascript:;" :class="{'active': queryParams.filter == group.code}" @click="changeFilter(group.code)">{{group.name}} <span class="count">{{group.total}}</span></a>
          </li>
        </ul>
      </div>
    </div>

    <section id="kunde-scrollable-container" class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen kontrakter'" :large="true" :icon="'glyph-medium-contract'"/>

      <a v-if="kunde.Sperret !== 'T'" href="javascript:;" @click="openCreateModal()" class="button action fixed right glyph data-modal">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
        <span>Ny kontrakt</span>
      </a>

      <table v-if="items.length > 0" class="large fixed visible evenodd sortable clickable contracts table-filter">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" v-bind:key="item.Kontraktnr" @click="showKontraktItem(item)">
            <td class="all" :class="item.kontrakttype.code">
              <span class="icon-container">
                <span class="avatar small icon">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
                </span>
                <a href="javascript:;" class="primary-title">{{item.Kontraktnr}}</a>
              </span>
            </td>
            <td>{{item.kontrakttype ? item.kontrakttype.info : '-'}}</td>
            <td>{{item.avdeling ? item.avdeling.Beskrivelse : '-'}}</td>
            <td class="show-for-large">{{item.total_objekt | toInteger}} objekter</td>
            <td class="show-for-medium">
              <span v-if="item.Registrertsignert" class="status green" :title="item.Registrertsignert">Signert</span>
              <span v-else class="status" :class="kontraktStatusClass(item.status)">{{item.status_text}}</span>
            </td>
            <td class="show-for-medium"><span class="opacity-60">{{item.Sist_endret_tid | avantidate}}</span></td>
            <td class="align-right">
              <span v-if="item.mottaker" class="avatar name left" :class="strToAvatarClass(item.mottaker.initials)">{{item.mottaker.initials}} <span class="name">{{item.mottaker.full_name}}</span></span>
              <span v-else class="avatar name left" :class="strToAvatarClass('-')">- <span class="name">Ingen ansvarlig</span></span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import { mapGetters } from 'vuex'

export default {
  name: 'KundeCardShowTabKontrakt',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Kontrakt', sortKey: 'Kontraktnr', class: ''},
        {name: 'Type', sortKey: 'Kontrakttype', class: ''},
        {name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: 'show-for-large'},
        {name: 'Objekter', sortKey: 'total_objekt', class: 'show-for-large'},
        {name: 'Status', sortKey: 'status', class: 'show-for-medium'},
        {name: 'Dato endret', sortKey: 'Sist_endret_tid', class: 'show-for-medium'},
        {name: 'Ansvarlig', sortKey: 'mottaker.Fornavn', class: 'align-right'}
      ]
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.

    this.currentPage = this.queryParams.page || 1
  },
  updated () {
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }
    })
  },
  mounted () {
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }
    })
  },
  filters: {
    toInteger (value) {
      return !value ? 0 : parseInt(value)
    }
  },
  computed: {
    ...mapGetters('kundekontrakt', [
      'items',
      'groups',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundekontrakt/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundekontrakt/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },
    changeFilter: function (code) {
      var vm = this

      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = 1
        copiedParams.page = vm.currentPage

        if (vm.groups.hasOwnProperty(code)) {
          copiedParams.filter = code
        } else {
          copiedParams.filter = '0'
        }

        vm.$store.dispatch('kundekontrakt/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    showKontraktItem: function (item) {
      bus.$emit('show-kunde-kontrakt', item)
    },
    openCreateModal: function () {
      this.openModal(
        'kunde-kontrakt-create-modal',
        {
          kunde: this.kunde
        }
      )
    },
    toggleFilterSidebar: function () {
      this.$helpers.toggleSidebar('subnav')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabKontrakt.vue